
import React, { useEffect, useState } from 'react'
import { IconButton, Tooltip } from '@mui/material'
import ModalController from '../../components/ModalController/ModalSearchHistoryPatient'
import Box from '@mui/material/Box';
import ContactConference from './ContactConference'
import { SystemPatientInformationData } from '../consult_doctor/SystemPatientInformationData'
import WebViewPhrDoctor from './WebViewPhrDoctor';
import { useContext } from 'react';
import { MainContext } from '../../App';
import { useDispatch } from 'react-redux';
import { menuActive } from '../../store/menuSlice';
import PointOfCare from '../consult_doctor/point_of_care/PointOfCare';

import { MdOutlineMedicalInformation, MdContactPhone, MdBloodtype } from "react-icons/md";
import { FaHandHoldingMedical } from "react-icons/fa6";
import { LuDoorOpen } from "react-icons/lu";
import { FaBedPulse } from "react-icons/fa6";
import { BsSmartwatch } from "react-icons/bs";
import { SiSmartthings } from "react-icons/si";

import { sxBtnSelect, sxBtnSelectA, sxBtnSelectB } from "../../components/ButtonCustomize";

function PatientHistory() {
    const { initStatePopup } = useContext(MainContext);
    const [initModalController, setInitModalController] = useState(true);
    const [success, setSuccess] = useState(false);
    const [pid, setPid] = useState('');
    const [hwRegistered, setHWRegistered] = useState(false);

    const [value, setValue] = useState(0);
    const [patientPage, setPatientPage] = useState(0);
    const [pocPage, setPOCPage] = useState(0);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(menuActive('ประวัติผู้ป่วย'))
    }, []);

    useEffect(() => {
        if (initStatePopup?.['actvie'])
            setInitModalController(initStatePopup['actvie']);
    }, [initStatePopup]);

    useEffect(() => {
        console.log(pid);
    }, [pid])

    return (<>

        {initModalController ?
            <ModalController onClose={setInitModalController} success={setSuccess} pid={setPid} hwRegist={setHWRegistered}/>
            : null
        }

        {success &&
            <>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'start',
                    mt: 1, mb: 2, ml: '3rem',
                    '@media (max-width: 512px)': {
                        ml: 0,
                        justifyContent: 'center',
                    }
                }}>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: 6,
                        pr: 5,
                        '@media (max-width: 512px)': {
                            ...(
                                value === 0 ? {
                                    gap: 0.6,
                                    pr: 1.5,
                                }
                                : value === 1 ? {
                                    gap: 0.5,
                                    pr: 1.25,
                                }
                                : {
                                    gap: 3,
                                    pr: 0,
                                }
                            )
                        }
                    }}>
                        <Tooltip title="ข้อมูลทางการแพทย์">
                            <IconButton onClick={() => { setValue(0) }} aria-label="Medical Records" size="large" color="c_button"
                                {...(value === 0 && sxBtnSelectA)}
                            >
                                <MdOutlineMedicalInformation/>
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Point of Care">
                            <IconButton onClick={() => { setValue(1) }} aria-label="Point of Care" size="large" color="c_button"
                                {...(value === 1 && sxBtnSelectA)}
                            >
                                <FaHandHoldingMedical/>
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="ติดต่อ">
                            <IconButton onClick={() => { setValue(2) }} aria-label="Contact" size="large" color="c_button"
                                {...(value === 2 && sxBtnSelect)}
                            >
                                <MdContactPhone />
                            </IconButton>
                        </Tooltip>
                    </Box>

                    { value === 0 &&
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: 6,
                            pl: 5,
                            boxShadow: "-1px 0px #E3E9F2",
                            '@media (max-width: 512px)': {
                                gap: 0.6,
                                pl: 1.5,
                            }
                        }}>

                            <Tooltip title="ประวัติผู้ป่วยนอก">
                                <IconButton
                                    onClick={() => { setPatientPage(0); }} aria-label="Outpatient Records" size="large" color="c_button"
                                    {...(patientPage === 0 && sxBtnSelectB)}
                                >
                                    <LuDoorOpen/>
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="ประวัติการนอนโรงพยาบาล">
                                <IconButton
                                    onClick={() => { setPatientPage(1); }} aria-label="Inpatient Records" size="large" color="c_button"
                                    {...(patientPage === 1 && sxBtnSelectB)}
                                >
                                    <FaBedPulse/>
                                </IconButton>
                            </Tooltip>

                        </Box>
                    }

                    { value === 1 &&
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: 6,
                            pl: 5,
                            boxShadow: "-1px 0px #E3E9F2",
                            '@media (max-width: 512px)': {
                                gap: 0.5,
                                pl: 1.25,
                            }
                        }}>

                            <Tooltip title="ผลตรวจเลือด">
                                <IconButton onClick={() => { setPOCPage(0) }} aria-label="Blood Test Results" size="large" color="c_button"
                                    {...(pocPage === 0 && sxBtnSelectB)}
                                >
                                    <MdBloodtype/>
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Smart Watch">
                                <IconButton onClick={() => { setPOCPage(1) }} aria-label="Smart Watch Results" size="large" color="c_button"
                                    {...(pocPage === 1 && sxBtnSelectB)}
                                >
                                    <BsSmartwatch/>
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="ผลการคัดกรองสุขภาพ">
                                <IconButton onClick={() => { setPOCPage(2) }} aria-label="IoT Results" size="large" color="c_button"
                                    {...(pocPage === 2 && sxBtnSelectB)}
                                >
                                    <SiSmartthings />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    }

                </Box>

                <Box sx={{ '@media (max-width: 600px)': {display:'flex', flexDirection:'column', alignItems:'center'} }}>
                    { value === 0 && <SystemPatientInformationData pid={pid} value={patientPage}/> }
                    { value === 1 && <PointOfCare pid={pid} hwRegist={hwRegistered} page={pocPage}/> }
                    { value === 2 &&
                        <Box sx={{
                            background: '#FFFFFF',
                            width: { xl: '600px', lg: '400px', md: '400px', sm: '350px', xs: '320px' },
                            borderRadius: '1rem',
                            margin: '0 auto',
                            padding: '3rem 0 2rem 0',
                            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px'
                        }}>
                            <ContactConference pid={pid} />
                        </Box>
                    }
                </Box>
            </>
        }
    </>)
}

export default PatientHistory